module.exports = __webpack_public_path__ + "static/test_app_visual-c1d2e3c9732d1d8b21588cbd7d3ff140.svg";